import Papa from "papaparse";
import { FORMULA_LEAD } from "../../domain/csvSafety";
import type { ExportTable } from "../types";

// GAVION B1-T9: FORMULA_LEAD now lives in domain/csvSafety.ts (shared with the lead import).
export { FORMULA_LEAD };

/** RFC 4180 CSV with `;` (fr-CA Excel); nested values as JSON; spreadsheet formulas neutralised (escapeFormulae). */
export const rowsToCsv = (rows: readonly Record<string, unknown>[]): string =>
  rows.length
    ? Papa.unparse(
        rows.map((r) =>
          Object.fromEntries(
            Object.entries(r).map(([k, v]) => [
              k,
              v !== null && typeof v === "object"
                ? JSON.stringify(v)
                : (v ?? ""),
            ]),
          ),
        ),
        { newline: "\r\n", delimiter: ";", escapeFormulae: FORMULA_LEAD },
      )
    : "";

export const csvFileName = (table: ExportTable, from: string, to: string) =>
  `gavion-${table}-${from}_${to}.csv`;

export const downloadCsv = (name: string, csv: string) => {
  const url = URL.createObjectURL(
    new Blob([String.fromCharCode(0xfeff) + csv], {
      type: "text/csv;charset=utf-8",
    }),
  );
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 0);
};
